import React from "react";
import PropTypes from "prop-types";
import { Navigate, useParams } from "react-router-dom";

/**
 * HomeTabRedirect - permanently redirects a legacy board-report sub-route
 * (/board-reports/:id/config|template|runs) to the corresponding tab of the
 * unified report home (/board-reports/:id?tab=...), preserving any external or
 * bookmarked deep links after the tabbed restructure.
 */
export const HomeTabRedirect = ({ tab }) => {
  const { id } = useParams();
  const search = tab && tab !== "overview" ? `?tab=${tab}` : "";
  return <Navigate to={`/board-reports/${id}${search}`} replace />;
};

HomeTabRedirect.propTypes = {
  tab: PropTypes.string,
};

export default HomeTabRedirect;
